<div class="home-page-holder">
  <img src="../../../assets/images/home.png"/>
  <div class="home-page-message">
    <div>Welcome to the BMSLab Twente Feedback page!</div>
    <div>Everything went fine, but there is not much you can find here.</div>
    <div>In order to see your feedback, please check your email or contact the researcher!</div>
  </div>
</div>
